/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Toaster } from "react-hot-toast";
import { useTheme } from "../providers/theme";
import { StateOSDModalVW } from "../widgets/StateOSDModalVW";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";

const getWalletModule = () => {
  const vapp = VApplication.getInstance();
  return vapp.getSync("services.WalletconnectModule") as WalletconnectModule;
};

// core styles
import "../vlinder.min.css";

export const Accessories = () => {
  const theme = useTheme();
  if (sessionStorage.getItem("reloaded") != null) {
    console.log("page was reloaded");
    const module = getWalletModule();
    module
      .killSession()
      .then((res) => {})
      .catch((err) => {});
  } else {
    console.log("page was not reloaded");
  }
  sessionStorage.setItem("reloaded", "yes");

  window.addEventListener("beforeunload", async function (e) {
    const module = getWalletModule();
    module
      .killSession()
      .then((res) => {})
      .catch((err) => {});

    // e.preventDefault();
    // e.returnValue = '';
  });

  return (
    <>
      <StateOSDModalVW />
      <Toaster
        toastOptions={{
          className: "",
          duration: 8000,
          style: {
            borderLeft: `4px solid ${theme?.colors?.primary}`,
            padding: "16px",
            color: theme?.colors?.black,
            fontSize: 15,
            fontWeight: "bolder",
          },
          success: {
            style: {
              borderColor: theme?.colors?.toastSuccess,
            },
          },
          error: {
            style: {
              borderColor: theme?.colors?.toastError,
            },
          },
        }}
      />
    </>
  );
};
